import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { basketVM } from '../../viewmodels/basketVM';
import { ShoppingBasketService } from '../../../shared/services/shopping-basket.service';

@Component({
    selector: 'app-doc-basket-add',
    templateUrl: './doc-basket-add.component.html',
    styleUrls: ['./doc-basket-add.component.css']
})
/** doc-basket-add component*/
export class DocBasketAddComponent implements OnInit {
  @Input() indexId: string;
  @Input() doctype: string;
  @Input() pagecount: number;
  @Input() docbeginbook: string;
  @Input() docbeginpage: string;
  @Input() currentindex: number;
  @Input() begindocnum: string;
  @Input() docId: string;
  @Input() basketItems: Array<basketVM>;
  @Output() toggle = new EventEmitter<Object>();
  basketItem: basketVM;
  machineType: number = 0;
  paymentMethod: string = '1';
  error: any;
  popupVisible: boolean = false;
  Message: string;

  constructor(private service: ShoppingBasketService) {

  }

  ngOnInit() {
    let loc = localStorage.getItem("machineLocation")
    this.machineType = loc == '1' ? 1 : loc == '2' ? 2 : 0;
    if (this.machineType === 2)
      this.paymentMethod = '3';

    console.log('doc  ' + this.doctype + ' ' + this.docbeginbook + ' ' + this.docbeginpage);
  }

  addToBasket(iswholedoc: boolean) {
    console.log("add to basket");
    //    console.log("docId" + this.docId + "begdocnum" + this.begindocnum + "begbook" + this.docbeginbook + "begpage" + this.docbeginpage + "currindex" + this.currentindex);
    console.log("indexID " + this.indexId);
    if (this.indexId) {
      ////Unindexed Doc
      var indexType = this.service.getUnindexedType(this.indexId);
      if (+this.indexId > 4 && +this.indexId < 20) {
        //grantor/tee indexes
        this.docbeginbook = indexType;
        this.docbeginpage = this.currentindex.toString();
      }
    }

    var index: number;
    console.log("Doc Num " + this.docbeginbook);
    if (this.begindocnum !== undefined)
      index = this.basketItems.findIndex(item => item.begindocnum === this.begindocnum && item.wholeDoc === iswholedoc);
    else
      index = this.basketItems.findIndex(item => item.beginBook === this.docbeginbook && item.beginPage === this.docbeginpage && item.wholeDoc === iswholedoc);
    ////exists
    console.log("index " + index.toString());
    if (index > -1) {
      if (iswholedoc) {
        console.log("Duplicate entry");
        if (this.begindocnum !== undefined)
          this.Message = "Document " + this.begindocnum + " is already added.";
        else
          this.Message = "Book/Page " + this.docbeginbook + "/" + this.docbeginpage + " is already added.";
        this.popupVisible = true;
      }
      else {
        if (this.begindocnum !== undefined && this.basketItems[index].pages.indexOf((this.currentindex - 1).toString()) > -1) {
          this.Message = "Document " + this.begindocnum + ", p." + (this.currentindex) + " is already added.";
          this.popupVisible = true;
        }
        else if (this.begindocnum === undefined && this.basketItems[index].pages.indexOf(this.currentindex.toString()) > -1) {
          this.Message = "Book/Page " + this.docbeginbook + "/" + this.docbeginpage + ", p." + (this.currentindex) + " is already added.";
          this.popupVisible = true;
        }
        else {
          this.basketItems[index].pageCount = this.basketItems[index].pageCount + 1;
          //update local storage
          let basketls = JSON.parse(localStorage.getItem("basket"));
          basketls[index].pageCount = basketls[index].pageCount + 1;
          localStorage.setItem("basket", JSON.stringify(basketls));

          if (this.begindocnum !== undefined) {
            this.basketItems[index].pages.push((this.currentindex - 1).toString());
            //update local storage
            let basketls = JSON.parse(localStorage.getItem("basket"));
            basketls[index].pages.push((this.currentindex - 1).toString());
            localStorage.setItem("basket", JSON.stringify(basketls));
            this.Message = "Document " + this.begindocnum + ", p." + (this.currentindex) + " is added successfully.";
          }
          else {
            this.basketItems[index].pages.push(this.currentindex.toString());
            //update local storage
            let basketls = JSON.parse(localStorage.getItem("basket"));
            basketls[index].pages.push(this.currentindex.toString());
            localStorage.setItem("basket", JSON.stringify(basketls));
            this.Message = "Book/Page " + this.docbeginbook + "/" + this.docbeginpage + ", p." + (this.currentindex) + " is added successfully.";
          }
          this.popupVisible = true;
        }
      }
    }

    ////not exists- create new basket item
    else {
      this.basketItem = new basketVM();
      this.basketItem.docType = this.doctype;


      if (this.indexId) {
        ////Unindexed
        this.basketItem.beginBook = this.docbeginbook;
        this.basketItem.beginPage = this.docbeginpage;
        this.basketItem.bookpage = 'U: ' + indexType;
        this.basketItem.dept = 'U';
        this.basketItem.docType = this.indexId;  //specifies which unindexed type
        this.basketItem.docId = '0';

      }

      //// Registered land document
      else if (this.begindocnum !== undefined) {
        this.basketItem.begindocnum = this.begindocnum;
        this.basketItem.bookpage = this.begindocnum;
        this.basketItem.docId = this.docId.toString();
        this.basketItem.dept = 'L';
      }

      ////Recorded land document
      else {
        this.basketItem.beginBook = this.docbeginbook;
        this.basketItem.beginPage = this.docbeginpage;

        if (this.doctype === 'PL')
          this.basketItem.bookpage = 'Plan B:' + this.docbeginbook + '/P:' + this.docbeginpage;
        else
          this.basketItem.bookpage = 'B:' + this.docbeginbook + '/P:' + this.docbeginpage;

        this.basketItem.dept = 'R';
        this.basketItem.docType = this.doctype;
        this.basketItem.docId = this.docId;
        //if (this.docId === "0" || this.doctype === null) {
        //  //images to be found in the bookpagebooks path
        //  this.basketItem.wholeDoc = true;
        //  this.basketItem.docType = 'U';
        //}

        console.log('add ' + this.basketItem.bookpage + ' ' + this.doctype + ' ' + this.pagecount + ' ' + this.docId)
      }
      this.basketItem.isEmail = false;
      this.basketItem.isDownload = false;
      this.basketItem.downloadAs = 'pdf';
      this.basketItem.wholeDoc = iswholedoc;
      if (iswholedoc) {
        this.basketItem.pageCount = this.pagecount;
      }
      else {
        this.basketItem.pageCount = this.pagecount;
        this.basketItem.pageCount = 1;
        if (this.begindocnum !== undefined)
          this.basketItem.pages = new Array<string>((this.currentindex - 1).toString());
        else
          this.basketItem.pages = new Array<string>(this.currentindex.toString());
      }
      this.basketItems.push(this.basketItem);

      //update local storage
      if (localStorage.getItem("basket") == null) {
        //let basketls = this.basketItem;
        localStorage.setItem("basket", JSON.stringify(this.basketItems));
      }
      else /*if (localStorage.getItem("basket").length > 0)*/ {
        let basketls = JSON.parse(localStorage.getItem("basket"));
        basketls.push(this.basketItem);
        localStorage.setItem("basket", JSON.stringify(basketls));
      }

      if (iswholedoc)
        if (this.begindocnum !== undefined)
          this.Message = "Document " + this.begindocnum + " is added successfully.";
        else
          this.Message = "Book/Page " + this.docbeginbook + "/" + this.docbeginpage + " is added successfully.";
      else
        if (this.begindocnum !== undefined)
          this.Message = "Document " + this.begindocnum + ", p." + (this.currentindex) + " is added successfully.";
        else
          this.Message = "Book/Page " + this.docbeginbook + "/" + this.docbeginpage + ", p." + (this.currentindex) + " is added successfully.";
      this.popupVisible = true;
    }

  }

}
